<script setup lang="ts">
interface CustomPolicyPaginatorInterface {
    page: number
    pagesCount: number
}

defineProps<CustomPolicyPaginatorInterface>()
const emit = defineEmits<{
    (e: 'paginate', value: number): void
}>()

const paginate = (page: number) => {
    emit('paginate', page)
}
</script>

<template>
    <v-pagination
        :model-value="page"
        :length="pagesCount"
        @update:model-value="paginate"
        :total-visible="4"
        active-color="primary"
        :class="{
            'isp-admin-paginator': true,
            'isp-admin-paginator--first-page': page === 1,
            'isp-admin-paginator--last-page': page === pagesCount || pagesCount === 0,
        }"
        rounded="circle"
        :size="36"
    />
</template>

<style>
    .isp-admin-paginator {
        .v-btn--icon.v-btn--density-compact {
            inline-size: 100%;
            padding: 0 0.5em;
        }
        .v-btn {
            inline-size: 40px !important;
            block-size: 40px !important;
            background-color: transparent!important;
        }

        .v-pagination__item {
            inline-size: 40px;
            block-size: 40px;
        }

        .v-pagination__item--is-active {
            border-radius: 50%;
            background-color: rgb(var(--v-theme-primary500));
            .v-btn__overlay {
                display: none;
            }

            .v-btn__content {
                color: #fff;
            }
        }
        .v-pagination__prev,
        .v-pagination__next {
            border: 2px solid rgb(var(--v-theme-primary));
            border-radius: 50%;
        }
    }

    .isp-admin-paginator--first-page {
        .v-pagination__prev {
            opacity: 0.2;
        }
        .v-btn--disabled {
            opacity: 1;
        }
    }

    .isp-admin-paginator--last-page {
        .v-pagination__next {
            opacity: 0.2;
        }
        .v-btn--disabled {
            opacity: 1;
        }
    }
</style>
